import React, { useEffect, useState } from 'react';
import Styles from './ModalVoucher.css';
import ContainerHome24 from '../../../../components/atoms/ContainerHome24';
import Button from '../../widgets/Button/Button';
import { useSimuladorEnergiaSolarState } from '../../model/state';
import { useScroll } from '../../../../utils/useLayout';
import Modal from '../../widgets/Modal/Modal';
import { getErrorData } from '../../shared/utils/error';
import TextField from '../../widgets/TextField/TextField';
import { useUpdateSimulation } from '../../api/use-update-simulation';
import clsx from 'clsx';
import { useValidateVoucher } from '../../api/use-validate-voucher';

const Wrapper = ({ children, modal = false, setOpen, open }) => {
  if (modal) {
    return (
      <Modal open={open} setOpen={setOpen} contentFill>
        {children}
      </Modal>
    );
  }

  return <>{children}</>;
};

function ModalVoucher() {
  const {
    setModalVoucher,
    modalVoucher,
    isMobile,
    showErrorStep,
    token,
    loading,
    EventHandler,
    offer,
  } = useSimuladorEnergiaSolarState();
  const { scrollToSelector } = useScroll();

  const [validVoucher, setValidVoucher] = useState(false);
  const [voucher, setVoucher] = useState('');
  const [lastValidatedVoucher, setLastValidatedVoucher] = useState('');

  const updateSimulation = useUpdateSimulation({ token });
  const validateVoucher = useValidateVoucher({ token });

  const hasApplied = !!offer?.voucherApplied && offer?.voucherApplied === voucher;
  const locked = updateSimulation.isPending || validateVoucher.isPending || loading;

  const closeModal = () => {
    if (locked) return;

    setVoucher('');
    setLastValidatedVoucher('');
    setModalVoucher(false);
    setValidVoucher(false);

    if (!isMobile) return;

    scrollToSelector('.proposal .btn-insert-voucher');
  };

  const handleSubmit = async (v = '') => {
    try {
      await updateSimulation.mutateAsync({ voucher: v });
      EventHandler.emit('refetch-best-offer');
      closeModal();
    } catch (error) {
      showErrorStep({
        ...getErrorData(error),
        title:
          v === 'remove-voucher'
            ? 'Não foi possível remover o cupom'
            : 'Não foi possível aplicar o cupom',
        ctx: 'api-update-voucher',
      });
    }
  };

  const handleVoucherChange = async (v, submit = false) => {
    if (locked) return;

    if (!v) {
      setValidVoucher(false);
      return;
    }

    if (!!lastValidatedVoucher && v === lastValidatedVoucher) {
      if (submit) {
        return handleSubmit(v);
      }
    }

    try {
      await validateVoucher.mutateAsync({ voucher: v });
      setValidVoucher(true);

      if (submit) {
        return handleSubmit(v);
      }
    } catch (error) {
      setValidVoucher(false);
    } finally {
      setLastValidatedVoucher(v);
    }
  };

  const removeVoucher = async () => {
    if (locked) return;

    return handleSubmit('remove-voucher');
  };

  useEffect(() => {
    setVoucher(offer?.voucherApplied || '');
  }, [offer?.voucherApplied]);

  if (!modalVoucher) return null;

  return (
    <Wrapper
      modal={!isMobile}
      open={modalVoucher}
      setOpen={(v) => {
        if (locked) return;
        if (!v) closeModal();
        setModalVoucher(v);
      }}
    >
      <div className="modal-voucher">
        <ContainerHome24>
          <p className="text-title-desk">Inserir cupom</p>
          <p className="text-title">
            Tem um cupom? Aproveite para aplicar desconto na sua simulação.
            <br />
            <br />
            Informe o código do cupom abaixo.
          </p>

          <form
            className={clsx('field-wrapper', (validVoucher || hasApplied) && 'valid')}
            onSubmit={(ev) => {
              ev.preventDefault();
              if (locked) return;

              if (hasApplied) {
                removeVoucher();
                return;
              }

              handleVoucherChange(voucher, true);
            }}
          >
            <TextField
              disabled={locked}
              type="text"
              label="Código do cupom"
              value={voucher}
              onChange={(ev) => {
                setVoucher(ev.target.value);
              }}
              onBlur={(ev) => {
                setVoucher(ev.target.value);
                handleVoucherChange(ev.target.value);
              }}
              maskFunction={(v) => `${v || ''}`.trim().toUpperCase().slice(0, 40)}
              endAdornment={
                validVoucher || hasApplied ? (
                  <>
                    <img src="assets/simulador-energia-solar/jornada/ic-check-green.svg" alt="" />
                  </>
                ) : null
              }
            />
            <Button id="btn-add-voucher" variant="flat-red" type="submit" disabled={locked}>
              {hasApplied ? 'Remover cupom' : 'Adicionar cupom'}
            </Button>
          </form>

          {isMobile && (
            <div className="btn-wrapper">
              <Button
                variant="red"
                disabled={loading || !voucher || updateSimulation.isPending}
                onClick={closeModal}
              >
                Continuar
              </Button>
            </div>
          )}
        </ContainerHome24>
      </div>
      <style jsx>{Styles}</style>
    </Wrapper>
  );
}

export default ModalVoucher;
